import {build, date} from '../../package.json'

const Version = () => {
  return <div style={{fontSize: '12px', color: "lightgrey", position: 'fixed', left: 0, bottom: 0}}>
    {date}-{build}
  </div>
}

export default Version;